import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      d="M19 12V6a1 1 0 0 1 2 0v5h5a1 1 0 0 1 0 2h-6a1 1 0 0 1-1-1m-7 7H6a1 1 0 0 0 0 2h5v5a1 1 0 0 0 2 0v-6a1 1 0 0 0-1-1m14 0h-6a1 1 0 0 0-1 1v6a1 1 0 0 0 2 0v-5h5a1 1 0 0 0 0-2M12 5a1 1 0 0 0-1 1v5H6a1 1 0 0 0 0 2h6a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1"
    />
  </svg>
);
const SvgIconCornersIn = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconCornersIn);
export default Memo;
